import {
	AuthInterceptor,
	NgSharedModule,
	FrontendLanguageBridge,
	AppTrpcService,
	AppTrpcServiceInjectionToken,
	AuthService,
	CsrfService,
	IdbService,
} from '@lg/ng-shared'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import * as $Modules from './Module/$modules'

// import { BackendService } from './services/backend.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { BrowserModule } from '@angular/platform-browser'
import { NgModule, inject, provideZonelessChangeDetection } from '@angular/core'

import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { Declarations } from './config/shared/declarations'
import { MaterialModules } from './material.modules'
// import { StoreModule } from '@ngrx/store';
// import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { ComponentStore } from '@ngrx/component-store'
// import { EffectsModule } from '@ngrx/effects'
// import { Effects } from './store/effects'
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http'
// import { reducerFactory } from './store/reducers';
import { DateAdapter } from '@angular/material/core'
// import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter'
import { MAT_DATE_LOCALE } from '@angular/material/core'
import { MAT_DATE_FORMATS } from '@angular/material/core'
import { PdfComponent } from '@lg/ng-shared'
import { DateFnsAdapter } from '@angular/material-date-fns-adapter'
import {
	BaseChartDirective,
	provideCharts,
	withDefaultRegisterables,
} from 'ng2-charts'
import { DateFnsLocales } from './config/shared/config'
import { ChevronController, ChevronElement } from '@lg/ng-shared'

const defaultRegisterables = withDefaultRegisterables()

@NgModule({
	declarations: [AppComponent, ...Declarations],
	imports: [
		BrowserModule,
		NgSharedModule,
		AppRoutingModule,
		BrowserAnimationsModule,
		FormsModule,
		ReactiveFormsModule,
		...MaterialModules,
		HttpClientModule,
		BaseChartDirective,
		// StoreModule.forRoot(<any>{}, {
		// 	reducerFactory,
		// 	runtimeChecks: {
		// 		strictStateImmutability: false,
		// 		strictActionImmutability: false,
		// 	}
		// }),
		// StoreDevtoolsModule.instrument({ maxAge: 50 }),
		// EffectsModule.forRoot([Effects]),
		PdfComponent,
	],
	providers: [
		ComponentStore,
		{ provide: DateAdapter, useClass: DateFnsAdapter, deps: [MAT_DATE_LOCALE] },
		//   { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS] },
		{
			provide: MAT_DATE_FORMATS,
			useValue: {
				parse: {
					dateInput: ['dd.MM.yy', 'dd.MM.yyyy'],
				},
				display: {
					dateInput: 'dd.MM.yyyy',
					monthYearLabel: 'MMM yyyy',
					dateA11yLabel: 'LL',
					monthYearA11yLabel: 'MMMM yyyy',
				},
			},
		},
		{
			provide: MAT_DATE_LOCALE,
			useFactory: () => FrontendLanguageBridge.dateLocale,
		},
		{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
		{ provide: AppTrpcServiceInjectionToken, useClass: AppTrpcService },
		{ provide: AuthService, useClass: AuthService },
		{ provide: CsrfService, useClass: CsrfService },
		{ provide: IdbService, useClass: IdbService },
		provideZonelessChangeDetection(),
		provideCharts({
			...defaultRegisterables,
			registerables: [
				...(defaultRegisterables.registerables ?? []),
				ChevronController,
				ChevronElement,
			],
		}),
	],
	bootstrap: [AppComponent],
})
export class AppModule {
	constructor() {
		// private backendService: BackendService
		$Modules // don't remove; important for avoiding circular dependency issues!
		FrontendLanguageBridge.init()
		FrontendLanguageBridge.θsetDateLocales(DateFnsLocales)
		inject(AuthService).heartbeat$.subscribe()
	}
}
